import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";

const KEY = "nerolia_cookie_consent";

function loadTrackers(ga4Id, pixelId) {
  if (ga4Id && !window.__ga4Loaded) {
    window.__ga4Loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4Id)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ga4Id);
  }
  if (pixelId && !window.__fbqLoaded) {
    window.__fbqLoaded = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
  }
}

export default function CookieBanner() {
  const { t } = useLang();
  const settings = useSettings();
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY));

  useEffect(() => {
    if (consent === "accepted") loadTrackers(settings.ga4_id, settings.meta_pixel_id);
  }, [consent, settings.ga4_id, settings.meta_pixel_id]);

  if (consent) return null;

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setConsent(value);
  };

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookies" data-testid="cookie-banner">
      <div className="cookie-banner__text">
        <strong>{t("cookie.title")}</strong>
        <p>
          {t("cookie.text")}{" "}
          <Link to="/pages/cookies" data-testid="cookie-more">{t("cookie.more")}</Link>
        </p>
      </div>
      <div className="cookie-banner__actions">
        <button className="cookie-btn ghost" onClick={() => decide("refused")} data-testid="cookie-refuse">
          {t("cookie.refuse")}
        </button>
        <button className="cookie-btn" onClick={() => decide("accepted")} data-testid="cookie-accept">
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
}
